import React from 'react';
import { DrawerContent, DrawerContentProps } from '@chakra-ui/react';

export type DrawerContainerProps = DrawerContentProps;

export const DrawerContainer: React.FC<DrawerContainerProps> = ({
  children,
  m = { base: 4, md: 6 },
  mr = { base: 2, md: 4 },
  maxH = 'calc(100vh - 48px)',
  borderRadius = 'lg',
  ...rest
}) => {
  return (
    <DrawerContent
      m={m}
      mr={mr}
      maxH={maxH}
      borderRadius={borderRadius}
      {...rest}>
      {children}
    </DrawerContent>
  );
};
